import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionService } from '../services/question.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../services/notification.service';
import { AuthorizationService } from '../services/authorization.service';

@Component({
  selector: 'app-manage-categories',
  templateUrl: './manage-categories.component.html',
  styleUrls: ['./manage-categories.component.scss']
})
export class ManageCategoriesComponent implements OnInit, OnDestroy {
  public category_form: FormGroup
  category_list = [];

  modalView
  category_Id_name
  form_name = 'Add Category'
  constructor(private renderer: Renderer2,
    private modalReview: NgbModal,
    private formBuilder: FormBuilder,
    private ns: NotificationService,
    private question_service: QuestionService,
    public perm: AuthorizationService) {
    this.renderer.addClass(document.body, 'manageCategory');
    this.category_Id_name = 'Parent Category';
  }

  ngOnInit() {
    this.get_categories();
    this.validateFrom();
  }

  ngOnDestroy(): void {
    if (this.modalView) {
      this.modalView.close();
    }
  }

  validateFrom() {
    this.category_form = this.formBuilder.group({
      catgoryName: ['', Validators.required],
      catgoryId: ['', Validators.required],
    })
  }
  manageCategoryEvent(content) {
    this.modalView = this.modalReview.open(content, { windowClass: 'manageCategoryModal', centered: true });
    this.edit_right = false;
    this.category_Id_name = 'Parent Category';
    this.category_form.reset();
  }
  edit_right = false;
  open_edit_category(item, content) {
    this.manageCategoryEvent(content);
    this.category_form.controls.catgoryName.setValue(item.name);
    let id = item.id;
    this.category_form.controls.catgoryId.setValue(id);
    this.edit_right = true;
    this.category_Id_name = 'Category Id';
    this.category_Id_name == 'Category Id' ? this.form_name = 'Edit Category' : this.form_name = 'Add Category';
    
  }
  categorie_list_info = [];
  get_category_list = [];
  get_categories() {
    this.question_service.get_categories().subscribe(get => {
      this.get_category_list = get.message;
      this.arrange_categories(get.message);
    })
  }

  parents = [];
  category_list_value = [];
  arrange_categories(list) {
    let dict = list.reduce((p, c) => {
      p[c.id] = c;
      return p;
    }, {});

    let parentList2 = list.reduce((p, c) => {
      if (c.parent_id === "None") {
        p.push(c);
      } else {
        if (!dict[c.parent_id].child) {
          dict[c.parent_id].child = [];
        }
        dict[c.parent_id].child.push(c);
      }
      return p;
    }, []);
    this.category_list_value = Object.values(parentList2);
  }

  add_categories(body) {
    this.question_service.add_categories(body).subscribe(set => {
      this.ns.showNotification('success', set.message);
      this.get_categories();
      this.category_form.reset();
      this.modalView.close();
    },
      (err) => {
        this.ns.showNotification('error', "Not able to save the new category");
      })
  }

  edit_category(body) {
    this.question_service.edit_categories(body).subscribe(set => {
      this.ns.showNotification('success', set.message);
      this.get_categories();
      this.category_form.reset();
      this.modalView.close();
    },
      (err) => {
        this.ns.showNotification('error', "Not able to save the new category");
      })
  }

  formSubmit() {
    if (this.category_form.invalid) {
      this.ns.showNotification('info', 'Please correct form');
      return;
    }
    if (!this.edit_right) {
      this.add_categories(this.category_form.value);
    } else if (this.edit_right) {
      this.edit_category(this.category_form.value);
    }
  }
  active_id = 'mcAcc1-parent'
  show_category(id, index) {
    this.active_id = id + index;
  }

  //FOR BUILD FIX
  opened: boolean = false;

}
